import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ClientPaymentsPage = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!clientId) {
      navigate('/payments', { replace: true });
      return;
    }

    try {
      const existingFilters = JSON.parse(localStorage.getItem('paymentListing.filters') || '{}');
      const updatedFilters = {
        paymentMethod: 'all',
        paymentType: 'all',
        client: String(clientId),
        ...existingFilters,
      };
      localStorage.setItem('paymentListing.filters', JSON.stringify(updatedFilters));
      localStorage.setItem('paymentListing.paging', JSON.stringify({ page: 1, pageSize: 10 }));
      localStorage.setItem('paymentListing.sort', JSON.stringify({ field: 'payment_date', direction: 'desc' }));
    } catch (error) {
      console.error('Error preparing payment filters:', error);
    }

    navigate(`/payments?client=${clientId}`, { replace: true });
  }, [clientId, navigate]);

  return null;
};

export default ClientPaymentsPage;
